import { proxy } from 'valtio/vanilla'
import {
  gameStore,
  type Game,
  type GameState,
  selectNext,
  selectPrevious,
  selectGame,
  getSelectedGame,
  launchGame,
  exitGame,
  addGame,
  resetGameStore,
} from './game'
import {
  mouseStore,
  type MouseState,
  updateMouseActivity,
  setMouseOverGame,
  checkMouseInactivity,
  resetMouseStore,
} from './mouse'

/**
 * Arcade state managed by valtio (for backward compatibility)
 */
export interface ArcadeState {
  /** List of available games */
  games: Game[]
  /** Index of the currently selected game in the carousel */
  selectedIndex: number
  /** The game currently being played (null if none) */
  activeGame: Game | null
  /** Whether a game is currently loading */
  isLoading: boolean
  /** Mouse tracking state */
  mouse: MouseState
}

/**
 * The main arcade store (for backward compatibility)
 * This combines the separate game and mouse stores
 */
export const arcadeStore = proxy<ArcadeState>({
  get games() {
    return gameStore.games
  },
  set games(value) {
    gameStore.games = value
  },
  get selectedIndex() {
    return gameStore.selectedIndex
  },
  set selectedIndex(value) {
    gameStore.selectedIndex = value
  },
  get activeGame() {
    return gameStore.activeGame
  },
  set activeGame(value) {
    gameStore.activeGame = value
  },
  get isLoading() {
    return gameStore.isLoading
  },
  set isLoading(value) {
    gameStore.isLoading = value
  },
  get mouse() {
    return mouseStore
  },
  set mouse(value) {
    mouseStore.mouseX = value.mouseX
    mouseStore.mouseY = value.mouseY
    mouseStore.lastMouseActivity = value.lastMouseActivity
    mouseStore.isMouseOverGame = value.isMouseOverGame
    mouseStore.isCursorHidden = value.isCursorHidden
    mouseStore.cursorHideDelay = value.cursorHideDelay
  },
})

// Re-export game-related types and functions
export type { Game, GameState }
export {
  gameStore,
  selectNext,
  selectPrevious,
  selectGame,
  getSelectedGame,
  launchGame,
  exitGame,
  addGame,
  resetGameStore,
}

// Re-export mouse-related types and functions
export type { MouseState }
export { mouseStore, updateMouseActivity, setMouseOverGame, checkMouseInactivity, resetMouseStore }

/**
 * Reset all stores to initial state (useful for testing)
 */
export function resetStore(): void {
  resetGameStore()
  resetMouseStore()
}
